import type { BlogPost } from '@rumblefish/strapi/strapiTypes';
import type { GetStaticPaths, GetStaticProps } from 'next';
import { fetchBlogPosts } from '../../../utils/api/fetchStrapiData';

import { BlogArticle } from '../../../views/blogArticle';

export const getStaticProps: GetStaticProps = async () => {
  const blogPosts: BlogPost[] = await fetchBlogPosts();

  return {
    props: { blogPosts },
  };
};

export const getStaticPaths: GetStaticPaths = async () => {
  const blogPosts: BlogPost[] = await fetchBlogPosts();

  const paths = blogPosts.map((blogPost) => ({
    params: { slug: blogPost.slug },
  }));

  return {
    fallback: false,
    paths: paths,
  };
};

export default BlogArticle;
